import { z } from 'zod'

const subjectsSchema = z
  .object({
    userIds: z.array(z.string().uuid()).max(500),
    groupIds: z.array(z.string().uuid()).max(500),
    roleIds: z.array(z.string().uuid()).max(500),
  })
  .strict()
export const emptyVisibilitySubjects = () => ({
  userIds: [] as string[],
  groupIds: [] as string[],
  roleIds: [] as string[],
})
export const contentVisibilitySchema = z
  .object({ mode: z.enum(['everyone', 'restricted']), allow: subjectsSchema, deny: subjectsSchema })
  .strict()
export type ContentVisibility = z.infer<typeof contentVisibilitySchema>
export interface VisibilityPrincipal {
  userId: string
  groupIds: readonly string[]
  effectiveRoleIds: readonly string[]
}
function matches(subjects: ContentVisibility['allow'], principal: VisibilityPrincipal) {
  return (
    subjects.userIds.includes(principal.userId) ||
    subjects.groupIds.some((id) => principal.groupIds.includes(id)) ||
    subjects.roleIds.some((id) => principal.effectiveRoleIds.includes(id))
  )
}
export function evaluateContentVisibility(
  visibility: ContentVisibility | undefined,
  principal: VisibilityPrincipal,
) {
  if (!visibility) return true
  if (matches(visibility.deny, principal)) return false
  return visibility.mode === 'everyone' || matches(visibility.allow, principal)
}
